/**
 * 组织架构实体组件
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    InputNumber,
    Select,
    Upload,
    Image,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import $ from 'jquery';
import {
    AddRequestHeaders,
    UjoinParams,
    uploadImageButton,
    AliyunOSSclient,
    AliyunOSSDelete,
    uuid,
    GetBase64,
    rff,
} from '../../incs/FunHelper';
import ImgCrop from 'antd-img-crop';

import CNF from '../../incs/Config';

const MODULENAME = '组织架构';

const { Option } = Select;
const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [ulid, setULID] = useState('');    // 当前架构ULID
    const [orgInfoULID, setOrgInfoULID] = useState(null);   //  组织信息ULID
    const [orgStructuresLists, setOrgStructuresLists] = useState('');   //  组织架构列表

    const [upSID, setUpSID] = useState(null); //  上级组织sid
    const [level, setLevel] = useState(1); //  组织层级
    const [sn, setSN] = useState(1); //  层级序号
    const [orgFunctionType, setOrgFunctionType] = useState(CNF.orgFunctionTypes[1].value); //  组织职能类型
    const [title, setTitle] = useState(''); // 架构名称
    const [name, setName] = useState(''); // 负责人员
    const [description, setDescription] = useState(''); // 备注

    const [fileList, setFileList] = useState([]);    //  图片列表
    const [previewOpen, setPreviewOpen] = useState(false); //  图片预览是否打开
    const [previewImage, setPreviewImage] = useState(''); //  图片预览资源
    const [deleteFileList, setDeleteFileList] = useState([]); //  删除图片列表
    const [orgImageList, setOrgImageList] = useState([]);   //  组织人员图片列表

    const quit = () => {
        props.setOpen(false);
        setLoading(false);
        setULID('');
        setOrgStructuresLists('');
        setUpSID(null);
        setLevel(1);
        setSN(1);
        setOrgFunctionType(CNF.orgFunctionTypes[1].value);
        setTitle('');
        setName('');
        setDescription('');

        setFileList([]);
        setPreviewOpen(false);
        setPreviewImage('');
        setDeleteFileList([]);
        setOrgImageList([]);
    };

    const cancel = () => {
        quit();
        if (!props.record) {
            //  新增情况下取消，则删除已上传的图片
            aliyunOSSDeleteFileList(fileList);
            aliyunOSSDeleteFileList(deleteFileList);    //  待删除的文件
        } else {
            //  修改取消情况下，删除新增已上传的文件
            if (fileList && fileList.length > 0) {
                for (let i = 0; i < fileList.length; i++) {
                    let item = fileList[i];
                    //  如果不是原始图片则删除
                    if (!orgImageList.find(e => e.url === item.url)) {
                        AliyunOSSDelete(item);
                    }
                }
            }
        }
    };

    useEffect(() => {
        // 获取组织信息列表, 默认选中第一个
        if (props.orgInfosLists.length > 0) {
            setOrgInfoULID(props.orgInfosLists[0].key);
        }
    }, [props.orgInfosLists]);

    useEffect(() => {
        // 修改初始化
        if (props.record && props.record.key !== ulid) {
            setULID(props.record.key);
            setOrgInfoULID(props.record.org_info_ulid);
            setUpSID(props.record.up_sid);
            setLevel(props.record.level);
            setSN(props.record.sn);
            setOrgFunctionType(props.record.org_function_type);
            setTitle(props.record.title);
            setName(props.record.name);
            setDescription(props.record.description);

            // 拉取图片
            if (props.record.icon_uri) {
                let orgImageList = [];
                const url = CNF.ossApi + props.record.icon_uri;
                orgImageList.push({
                    uid: 1,
                    url: url,
                    path: props.record.icon_uri,
                    preview: url,
                    status: 'done',
                    percent: 100,
                });
                setFileList(orgImageList);
                setOrgImageList(orgImageList);
            }
        }
    }, [props.record, ulid]);


    useEffect(() => {
        /**
         * 获取上级组织架构下拉列表
         */
        const getUpStructuresLists = () => {
            const params = {
                'rss': 'list',
                'org_info_ulid': orgInfoULID,
                'status': CNF.status[0].value,
            };
            $.ajax({
                url: `${CNF.api}org/structures${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setOrgStructuresLists(data.dat);
                        }
                    }
                }
            })
        }
        if (props.open && orgInfoULID) {
            getUpStructuresLists();
        }
    }, [props.open, orgInfoULID])

    /**
     * 文件上传前钩子
     * @param {*} file 
     */
    const beforeUpload = (file) => {
        //  判断格式
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
            message.error('上传图片格式错误！', CNF.messageDuration);
            return false;
        }
        if (file.size > 5242880) {
            message.error('上传图片超过500KB, 请重新上传! ', CNF.messageDuration);
            return false;
        }
        return true;
    }

    /**
     * 图片预览操作绑定函数
     * @param {*} file 
     */
    const preview = (file) => {
        if (!file.preview) {
            if (file.originFileObj) {
                //  转换图片，用于缩略图展示
                GetBase64(file.originFileObj, (imageObj) => {
                    file.preview = imageObj;
                });
            } else {
                file.preview = file.url;
            }
        }
        setPreviewImage(file.preview || file.url);
        setPreviewOpen(true);
    }

    /**
     * 存储到阿里云
     * @param {*} file 
     * @returns 
     */
    const aliyunOSSUpload = (file, acl = 'public-read') => {
        const headers = {
            //  文件acl授权为公共读
            'x-oss-object-acl': acl
        }
        var params = {
            'oss': 'PutObject',
        }
        $.ajax({
            url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    const token = data.dat;
                    try {
                        let reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = () => {
                            // 路径由以下部分组成
                            // 项目代码+组织前缀+org+uuid+附件名（去除空格）
                            let path = CNF.projectCode.toLowerCase()
                            path += '/org';
                            path += '/' + props.preGroup;
                            path += '/' + uuid;
                            path += '/' + file.name.replace(/\s/g, '');
                            // 获取最新的文件列表
                            let newFileList = [...fileList];
                            AliyunOSSclient(token).multipartUpload(path, file,
                                {
                                    // 请求头
                                    headers,
                                    // 获取分片上传进度、断点和返回值
                                    progress: (p) => {
                                        setFileList(prevItems => {
                                            let newItems = [...prevItems]; // 创建数组的副本
                                            newItems[newItems.length - 1] = {
                                                ...newItems[newItems.length - 1],
                                                percent: parseInt(p * 100),
                                                status: p === 1 ? 'done' : 'uploading',
                                                url: CNF.ossApi + path,
                                                path: path,
                                            }; // 更新对象
                                            return newItems; // 返回新的数组
                                        })
                                    },
                                    // 分片数量
                                    parallel: Math.ceil(file.size / 1024 / 1024),
                                    //  设置分片大小，默认为1M。
                                    partSize: 1024 * 1024,
                                    mime: "text/plain",
                                }).then((result) => {
                                    //  上传成功
                                    if (result.res.status === 200) { }
                                }).catch((e) => {
                                    //  上传失败
                                    message.error(file.name + ' 上传失败！', CNF.messageDuration);
                                    setFileList(newFileList.pop());
                                });
                        }
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
        return false
    }

    /**
     * 删除图片列表
     * @param {*} deleteFileArr 
     */
    const aliyunOSSDeleteFileList = (deleteFileArr) => {
        for (let file of deleteFileArr) {
            //  从阿里云上删除
            AliyunOSSDelete(file);
        }
        setDeleteFileList([]);
    }


    const ok = () => {
        // 参数校验
        if (upSID === null) {
            message.error('上级组织不能为空！');
            return;
        }
        if (title === '') {
            message.error('架构标题不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'org/structures' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'org_info_ulid': orgInfoULID,
                'up_sid': upSID,
                'level': level,
                'sn': sn,
                'org_function_type': orgFunctionType,
                'title': title,
                'name': name,
                'icon_uri': fileList.length > 0 ? fileList[0].path : '',
                'description': description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                // 如果有需要删除的图片
                if (deleteFileList.length > 0) aliyunOSSDeleteFileList(deleteFileList); //  同步删除阿里云文件
                setTimeout(function () {
                    quit();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={540}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                style={{ top: 0 }}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={24}>{rff}组织实体</Col>
                    <Col span={24}>
                        <Select value={orgInfoULID}
                            style={{ width: '100%' }}
                            onChange={(value) => setOrgInfoULID(value)}
                            disabled={props.record ? true : loading}
                        >
                            {
                                props.orgInfosLists.length > 0 && props.orgInfosLists.map((item) => {
                                    return <Option key={item['key']} value={item['key']}>{item['name']}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}上级组织</Col>
                    <Col span={24}>
                        <Select
                            allowClear
                            placeholder='上级组织'
                            value={upSID}
                            style={{ width: '100%' }}
                            onChange={(value, params) => {
                                let level = params.level;
                                setUpSID(value ? value : null);
                                setLevel(level + 1);
                            }}
                            disabled={props.record ? true : loading}
                        >
                            {
                                orgStructuresLists.length > 0 && orgStructuresLists.map((item) => {
                                    //  岗位类不可再设下级组织
                                    if (parseInt(item['org_function_type']) !== parseInt(CNF.orgFunctionTypes[2].value)) {
                                        return <Option key={item['key']} level={item['level']} value={item['sid']}>{item['title']}</Option>
                                    }
                                    return null;
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={11}>{rff}组织层级</Col>
                    <Col span={11} offset={2}>{rff}层级序号</Col>
                    <Col span={11}>
                        <InputNumber
                            onChange={(value) => setLevel(value)}
                            placeholder='架构层级'
                            value={level}
                            min={1}
                            max={9}
                            style={{ width: '100%' }}
                            disabled={true}
                        />
                    </Col>
                    <Col span={11} offset={2}>
                        <InputNumber
                            onChange={(value) => setSN(value)}
                            placeholder='架构序号'
                            value={sn}
                            min={1}
                            max={12}
                            style={{ width: '100%' }}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}组织标题</Col>
                    <Col span={24}>
                        <Input
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder='请输入'
                            value={title}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={11}>{rff}组织职能</Col>
                    <Col span={11} offset={2}>负责人员</Col>
                    <Col span={11}>
                        <Select
                            value={orgFunctionType}
                            style={{ width: '100%' }}
                            onChange={(value) => setOrgFunctionType(value ? value : null)}
                            disabled={loading}
                        >
                            {
                                CNF.orgFunctionTypes && CNF.orgFunctionTypes.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={11} offset={2}>
                        <Input
                            placeholder="请输入"
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24} >人员图像</Col>
                    <Col span={24}>
                        <ImgCrop rotationSlider>
                            <Upload
                                beforeUpload={beforeUpload}
                                name='file'
                                listType='picture-card'
                                icon={<PlusOutlined />}
                                customRequest={(option) => { aliyunOSSUpload(option.file); }}
                                fileList={fileList}
                                onPreview={preview}
                                disabled={loading}
                                onChange={({ fileList: newFileList }) => {
                                    setFileList(newFileList);
                                }}
                                onRemove={(file) => {
                                    let _deleteFileList = deleteFileList;
                                    _deleteFileList.push(file);
                                    setDeleteFileList(_deleteFileList);
                                }}
                            >
                                {fileList.length >= 1 ? null : uploadImageButton}
                            </Upload>
                            {previewImage && (
                                <Image
                                    wrapperStyle={{ display: 'none', }}
                                    preview={{
                                        visible: previewOpen,
                                        onVisibleChange: (visible) => setPreviewOpen(visible),
                                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                    }}
                                    src={previewImage}
                                    disabled={loading}
                                />
                            )}
                        </ImgCrop>
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>组织描述</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='组织描述可写在这里...'
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity